<template>
  <section id="education-section" class="common-padding mb-20">
    <div class="flex flex-col">
      <h3
        id="educationTitle"
        v-html="educationTitle"
        class="heading-1 text-start leading-none font-bold uppercase"
      ></h3>
      <p
        class="heading-1 text-flax-smoke-400 text-opacity-50 hidden w-4/5 text-end font-extrabold sm:block"
      >
        <!-- Removed the counter -->
      </p>

      <div
        id="education-text"
        class="md:column-gap text-flax-smoke-300 mt-[5%] grid grid-cols-12 justify-end opacity-0 lg:grid"
      >
        <p
          class="heading-6 text-flax-smoke-300/85 col-span-4 text-center text-nowrap lg:col-start-2"
        >
          <!-- Removed the counter display -->
        </p>
        <p
          class="heading-4 font-fancy col-span-8 w-full text-balance sm:font-semibold lg:col-span-7"
        >
          Academic background and achievements.
        </p>
      </div>
    </div>

    <div class="mt-12 lg:mt-[10%]">
      <div
        v-for="(education, index) in educationData"
        :key="index"
        class="education-card border-b border-flax-smoke-500/40 py-5 last:border-b-0"
      >
        <div class="flex flex-col sm:flex-row sm:items-center gap-y-0.5 gap-x-5">
          <span class="font-title! font-bold uppercase tracking-wide text-flax-smoke-100 text-lg sm:text-xl shrink-0">
            York University
          </span>
          <span class="text-flax-smoke-300 text-base sm:text-lg flex-1 min-w-0">
            Honours Bachelor of Science in Computer Science
          </span>
          <span class="text-flax-smoke-500 text-base sm:text-lg font-mono whitespace-nowrap">
            Toronto, ON · Expected 2027
          </span>
        </div>

        <div class="mt-3 space-y-2">
          <p v-if="education.awards" class="text-flax-smoke-400/80 text-sm leading-relaxed">
            <span class="text-flax-smoke-200 font-medium">Awards:</span>
            International President's Scholarship of Excellence; Lassonde Scholarship; Faculty of Science Scholarship.
          </p>
          <p v-if="education.coursework" class="text-flax-smoke-400/80 text-sm leading-relaxed">
            <span class="text-flax-smoke-200 font-medium">Coursework:</span>
            Computer Vision, Advanced Object-Oriented Programming, Software Design, Introduction to Database Systems, Software Tools, Fundamentals of Data Structures, Human-Computer Interfaces, Theory of Computation, Computer Organization.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { animateSplitText } from '@/animations';
  import { textSplitterIntoChar } from '@/functions';
  import { onBeforeMount, onMounted, ref } from 'vue';

  const educationTitle = ref('Education /');

  const educationData = [
    {
      institution: 'York University',
      degree: 'Honours Bachelor of Science in Computer Science',
      location: 'Toronto, ON',
      period: 'Expected 2027',
      awards: [
        'International President\'s Scholarship of Excellence',
        'Lassonde Scholarship',
        'Faculty of Science Scholarship'
      ],
      coursework: 'Advanced Object-Oriented Programming, Software Design, Introduction to Database Systems, Software Tools, Fundamentals of Data Structures, Theory of Computation, Computer Organization'
    }
  ];

  onBeforeMount(() => {
    educationTitle.value = textSplitterIntoChar('Education / ', true);
  });

  onMounted(() => {
    animateSplitText(
      '#educationTitle .letters',
      '#education-text',
      0.7,
      0.01,
      0,
    );
  });
</script>

<style scoped>
  .education-card {
    /* Removed @apply directive */
  }
</style>
